import NavigationRoute from "./Routes/NavigationRoute";
import "./Css/stylesCustom.css";
function App() {
  return (
    <div>
      <NavigationRoute />
    </div>
  );
}

export default App;
